<template>
  <v-icon small class="mr-1" v-if="hasDeleteAccess" @click="$parent.$parent.$parent.confirmDeleteItem(deletingItem)">delete</v-icon>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      deletingItem: this.item
    }
  }
}
</script>